// extracted by mini-css-extract-plugin
export default {"appRoot":"FrontendQuizApp_appRoot__9cuxL"};